import { render, staticRenderFns } from "./HomeRecomendations.vue?vue&type=template&id=3f1b7b4e&scoped=true&"
import script from "./HomeRecomendations.vue?vue&type=script&lang=ts&"
export * from "./HomeRecomendations.vue?vue&type=script&lang=ts&"
import style0 from "./HomeRecomendations.vue?vue&type=style&index=0&id=3f1b7b4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b7b4e",
  null
  
)

export default component.exports